import React, { useState, useEffect, useCallback } from 'react';
import { useSelector } from 'react-redux';
import { intialPageSize } from 'constants';
import { formatDate, pageSizeChangeHandler } from 'utils/commonUtils';
import AssetNotes from './assetNotes/AssetNotes';
import { renderCellExpand } from 'components/Common/GridCell/GridCellExpand';
import DeltaDataGrid from 'utils/CommonDataGrid/CommonDataGrid';

const StudentAssets = () => {
  const [studentAssetList, setStudentAssetList] = useState({
    isLoading: false,
    rows: [],
    pageSize: intialPageSize,
    page: 1,
  });
  const { pageSize, page } = studentAssetList;

  const assignedAssets = useSelector(
    (state) => state.studentDetails?.item?.assignedAssets
  );

  useEffect(() => {
    if (assignedAssets) {
      fetchDataCourseInformation();
    }
  }, [pageSize, page, assignedAssets]);

  const fetchDataCourseInformation = () => {
    setStudentAssetList((previous) => ({
      ...previous,
      rows: assignedAssets?.map((item, index) => ({
        id: item.id,
        assetTag: item.assetTag,
        type: item.type.val,
        manu: item.manu,
        model: item.model,
        serial: item.serial,
        location: item.location.val,
        building: item.building.val,
        funding: item.funding.val,
        acquired: formatDate(item.acquired),
        verified: formatDate(item.verified),
        macAddress: item.macAddress,
        ipAddress: item.ipAddress,
        assignedUserType: item.assignedUserType,
        assignedUser: item.assignedUser,
        assignedAt: formatDate(item.assignedAt),
        assignedNote: item.assignedNote,
        assetNotes: item.notes?.map((item2, index2) => ({
          id: index2,
          date: item2.date,
          note: item2.note,
        })),
      })),
    }));
  };

  const columns = [
    {
      headerName: 'Asset Tag',
      field: 'assetTag',
      width: 130,
    },
    { headerName: 'Type', field: 'type', width: 150 },
    { headerName: 'Manufacturer', field: 'manu', width: 150 },
    {
      headerName: 'Model',
      field: 'model',
      width: 150,
    },
    { headerName: 'Serial', field: 'serial', width: 150 },
    { headerName: 'Location', field: 'location', width: 150 },
    {
      headerName: 'Building',
      field: 'building',
      renderCell: renderCellExpand,
      width: 150,
    },
    { headerName: 'Funding', field: 'funding', width: 150 },
    { headerName: 'Acquired', field: 'acquired', type: 'date', width: 150 },
    { headerName: 'Verified', field: 'verified', type: 'date', width: 150 },
    { headerName: 'Mac Address', field: 'macAddress', width: 150 },
    { headerName: 'Ip Address', field: 'ipAddress', width: 150 },
    { headerName: 'Assigned User Type', field: 'assignedUserType', width: 150 },
    { headerName: 'Assigned Student ', field: 'assignedUser', width: 150 },
    { headerName: 'Assigned At', field: 'assignedAt', width: 150 },
    { headerName: 'Assigned Note', field: 'assignedNote', width: 150 },
  ];
  const getDetailPanelContent = useCallback(
    ({ row }) => <AssetNotes row={row} />,
    []
  );
  const getDetailPanelHeight = useCallback(() => 'auto', []);

  const pageSizeChange = pageSizeChangeHandler(setStudentAssetList);

  return (
    <>
      <DeltaDataGrid
        listData={studentAssetList}
        columns={columns}
        getDetailPanelContent={getDetailPanelContent}
        getDetailPanelHeight={getDetailPanelHeight}
        setListData={pageSizeChange}
      />
    </>
  );
};

export default StudentAssets;
